import Vue from 'vue'
import Vuex from 'vuex'
import firebasePlugin from '@/plugins/firebase'
import global from '@/store/global'
import recipients from '@/store/recipients'
import batches from '@/store/batches'
import serviceFiles from '@/store/serviceFiles'
import users from '@/store/users'
import companies from '@/store/companies'
import financial from '@/store/financial'

Vue.use(Vuex)

const Store = new Vuex.Store({
  plugins: [
    firebasePlugin
  ]
})

// register modules
Store.registerModule('companies', companies, { preserveState: true })
Store.registerModule('global', global, { preserveState: true })
Store.registerModule('financial', financial, { preserveState: true })
Store.registerModule('recipients', recipients, { preserveState: true })
Store.registerModule('batches', batches, { preserveState: true })
Store.registerModule('serviceFiles', serviceFiles, { preserveState: true })
Store.registerModule('users', users, { preserveState: true })

export default Store
